import { InjectionToken, Injectable, Inject, Component, Input, Output, Renderer2, ElementRef, EventEmitter, ChangeDetectionStrategy, NgModule, defineInjectable, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
import * as ɵngcc0 from '@angular/core';
const DISQUS_SHORTNAME = new InjectionToken('DISQUS_SHORTNAME');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class DisqusService {
    /**
     * @param {?} shortname
     * @param {?} _document
     */
    constructor(shortname, _document) {
        this.shortname = shortname;
        this._document = _document;
    }
    /**
     * @return {?}
     */
    get DISQUS() {
        return this._document.defaultView.DISQUS;
    }
    /**
     * @return {?}
     */
    get disqus_config() {
        return this._document.defaultView.disqus_config;
    }
    /**
     * @param {?} config
     * @return {?}
     */
    set disqus_config(config) {
        this._document.defaultView.disqus_config = config;
    }
}
DisqusService.ɵfac = function DisqusService_Factory(t) { return new (t || DisqusService)(ɵngcc0.ɵɵinject(DISQUS_SHORTNAME), ɵngcc0.ɵɵinject(DOCUMENT)); };
DisqusService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: DisqusService, factory: DisqusService.ɵfac, providedIn: 'root' });
/** @nocollapse */
DisqusService.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [DISQUS_SHORTNAME,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
/** @nocollapse */ DisqusService.ngInjectableDef = defineInjectable({ factory: function DisqusService_Factory() { return new DisqusService(inject(DISQUS_SHORTNAME), inject(DOCUMENT)); }, token: DisqusService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DisqusService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [DISQUS_SHORTNAME]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class DisqusComponent {
    /**
     * @param {?} renderer
     * @param {?} el
     * @param {?} dService
     */
    constructor(renderer, el, dService) {
        this.renderer = renderer;
        this.el = el;
        this.dService = dService;
        /**
         * DISQUS events
         */
        this.newComment = new EventEmitter(true);
        this.ready = new EventEmitter(true);
        this.paginate = new EventEmitter(true);
    }
    /**
     * @return {?}
     */
    ngOnChanges() {
        /** Reset Disqus if any input changed */
        if (!this.dService.DISQUS) {
            this.addDisqusScript();
        }
        else {
            this.reset();
        }
    }
    /**
     * Add DISQUS script
     * @return {?}
     */
    addDisqusScript() {
        /** Set DISQUS config */
        this.dService.disqus_config = this.getConfig();
        /** @type {?} */
        const disqusScript = this.renderer.createElement('script');
        disqusScript.src = `//${this.dService.shortname}.disqus.com/embed.js`;
        disqusScript.async = true;
        disqusScript.type = 'text/javascript';
        this.renderer.setAttribute(disqusScript, 'data-timestamp', new Date().getTime().toString());
        this.renderer.appendChild(this.el.nativeElement, disqusScript);
    }
    /**
     * Reset DISQUS with the new config
     * @return {?}
     */
    reset() {
        this.dService.DISQUS.reset({
            reload: true,
            config: this.getConfig()
        });
    }
    /**
     * Create DISQUS config from the inputs
     * @return {?}
     */
    getConfig() {
        /** @type {?} */
        const self = this;
        return function () {
            this.page.identifier = self.identifier;
            this.page.url = self.validateUrl(self.url);
            this.page.title = self.title;
            this.category_id = self.category;
            this.language = self.language;
            /* Available callbacks are afterRender, onInit, onNewComment, onPaginate, onReady, preData, preInit, preReset */
            this.callbacks.onNewComment = [(e) => {
                    self.newComment.emit(e);
                }];
            this.callbacks.onReady = [(e) => {
                    self.ready.emit(e);
                }];
            this.callbacks.onPaginate = [(e) => {
                    self.paginate.emit(e);
                }];
        };
    }
    /**
     * @param {?} url
     * @return {?}
     */
    validateUrl(url) {
        /** Validate URL input */
        if (url) {
            /** @type {?} */
            const r = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
            if (r.test(url)) {
                return url;
            }
            else {
                console.warn('[Disqus]: Invalid URL');
            }
        }
        /** DISQUS will fallback to "Window.location.href" when URL is undefined */
        return undefined;
    }
}
DisqusComponent.ɵfac = function DisqusComponent_Factory(t) { return new (t || DisqusComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(DisqusService)); };
DisqusComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DisqusComponent, selectors: [["disqus"]], inputs: { url: "url", identifier: "identifier", title: "title", category: "category", language: "language" }, outputs: { newComment: "newComment", ready: "ready", paginate: "paginate" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 0, consts: [["id", "disqus_thread"]], template: function DisqusComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
    } }, encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
DisqusComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef },
    { type: DisqusService }
];
DisqusComponent.propDecorators = {
    url: [{ type: Input }],
    identifier: [{ type: Input }],
    title: [{ type: Input }],
    category: [{ type: Input }],
    language: [{ type: Input }],
    newComment: [{ type: Output }],
    ready: [{ type: Output }],
    paginate: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DisqusComponent, [{
        type: Component,
        args: [{
                selector: 'disqus',
                template: '<div id="disqus_thread"></div>',
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: DisqusService }]; }, { newComment: [{
            type: Output
        }], ready: [{
            type: Output
        }], paginate: [{
            type: Output
        }], url: [{
            type: Input
        }], identifier: [{
            type: Input
        }], title: [{
            type: Input
        }], category: [{
            type: Input
        }], language: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class DisqusModule {
    /**
     * @param {?} shortname
     * @return {?}
     */
    static forRoot(shortname) {
        return {
            ngModule: DisqusModule,
            providers: [
                { provide: DISQUS_SHORTNAME, useValue: shortname }
            ]
        };
    }
}
DisqusModule.ɵfac = function DisqusModule_Factory(t) { return new (t || DisqusModule)(); };
DisqusModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DisqusModule });
DisqusModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DisqusModule, [{
        type: NgModule,
        args: [{
                declarations: [DisqusComponent],
                exports: [DisqusComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DisqusModule, { declarations: [DisqusComponent], exports: [DisqusComponent] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { DisqusModule, DISQUS_SHORTNAME, DisqusService, DisqusComponent as ɵa };

